function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import * as React from 'react';
import { Banner } from '@shared/components/banner';
import { SitemapSections } from './sitemapSections';
import { SitemapNavBar } from './sitemapNavbar';
export const Sitemap = ({ sitemapSectionsDetails = [], bannerDetails = null })=>{
    const sectionRefs = new Map();
    if (sitemapSectionsDetails) {
        sitemapSectionsDetails.forEach((section)=>{
            sectionRefs[section.title] = /*#__PURE__*/ React.createRef();
        });
    }
    return /*#__PURE__*/ _jsxs("div", {
        className: "sitemap",
        role: "main",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "sitemap_banner",
                children: /*#__PURE__*/ _jsx(Banner, _object_spread({}, bannerDetails))
            }),
            sitemapSectionsDetails && /*#__PURE__*/ _jsxs(_Fragment, {
                children: [
                    /*#__PURE__*/ _jsx(SitemapNavBar, {
                        refs: sectionRefs,
                        titles: sitemapSectionsDetails.map((section)=>section.title)
                    }),
                    /*#__PURE__*/ _jsx(SitemapSections, {
                        sitemapSectionsDetails: sitemapSectionsDetails,
                        refs: sectionRefs
                    })
                ]
            })
        ]
    });
};
